export default __webpack_public_path__ + "static/media/icon__5.78773efe.svg";